/*
The list below was generated from this page: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values

Using this code: (run in console)
==========
keyNames = $("tr > td:first-child > code").toArray().map(a=>a.textContent.includes('"') ? a.textContent.match(/"(.+?)"/)[1] : a.textContent);
console.log(`let keyNames = [\n${keyNames.map(name=>`\t"${name}",`).join("\n")}\n];`);
==========
*/

export const keyNames = [
	"Unidentified",
	"Alt",
	"AltGraph",
	"CapsLock",
	"Control",
	"Fn",
	"FnLock",
	"Hyper",
	"Meta",
	"NumLock",
	"ScrollLock",
	"Shift",
	"Super",
	"Symbol",
	"SymbolLock",
	"Enter",
	"Tab",
	" ",
	"ArrowDown",
	"ArrowLeft",
	"ArrowRight",
	"ArrowUp",
	"End",
	"Home",
	"PageDown",
	"PageUp",
	"Backspace",
	"Clear",
	"Copy",
	"CrSel",
	"Cut",
	"Delete",
	"EraseEof",
	"ExSel",
	"Insert",
	"Paste",
	"Redo",
	"Undo",
	"Accept",
	"Again",
	"Attn",
	"Cancel",
	"ContextMenu",
	"Escape",
	"Execute",
	"Find",
	"Finish",
	"Help",
	"Pause",
	"Play",
	"Props",
	"Select",
	"ZoomIn",
	"ZoomOut",
	"BrightnessDown",
	"BrightnessUp",
	"Eject",
	"LogOff",
	"Power",
	"PowerOff",
	"PrintScreen",
	"Hibernate",
	"Standby",
	"WakeUp",
	"AllCandidates",
	"Alphanumeric",
	"CodeInput",
	"Compose",
	"Convert",
	"Dead",
	"FinalMode",
	"GroupFirst",
	"GroupLast",
	"GroupNext",
	"GroupPrevious",
	"ModeChange",
	"NextCandidate",
	"NonConvert",
	"PreviousCandidate",
	"Process",
	"SingleCandidate",
	"HangulMode",
	"HanjaMode",
	"JunjaMode",
	"Eisu",
	"Hankaku",
	"Hiragana",
	"HiraganaKatakana",
	"KanaMode",
	"KanjiMode",
	"Katakana",
	"Romaji",
	"Zenkaku",
	"ZenkakuHanaku",
	/*"GDK_KEY_dead_grave",
	"Qt::Key_Dead_Grave",
	"GDK_KEY_dead_acute",
	"Qt::Key_Dead_Acute",
	"GDK_KEY_dead_circumflex",
	"Qt::Key_Dead_Circumflex",
	"GDK_KEY_dead_tilde",
	"Qt::Key_Dead_Tilde",
	"GDK_KEY_dead_perispomeni",
	"GDK_KEY_dead_macron",
	"Qt::Key_Dead_Macron",
	"GDK_KEY_dead_breve",
	"Qt::Key_Dead_Breve",
	"GDK_KEY_dead_abovedot",
	"Qt::Key_Dead_Abovedot",
	"GDK_KEY_dead_diaeresis",
	"Qt::Key_Dead_Diaeresis",
	"GDK_KEY_dead_abovering",
	"Qt::Key_Dead_Abovering",
	"GDK_KEY_dead_doubleacute",
	"Qt::Key_Dead_Doubleacute",
	"GDK_KEY_dead_caron",
	"Qt::Key_Dead_Caron",
	"GDK_KEY_dead_cedilla",
	"Qt::Key_Dead_Cedilla",
	"GDK_KEY_dead_ogonek",
	"Qt::Key_Dead_Ogonek",
	"GDK_KEY_dead_iota",
	"Qt::Key_Dead_Iota",
	"GDK_KEY_dead_voiced_sound",
	"Qt::Key_Dead_Voiced_Sound",
	"GDK_KEY_dead_semivoiced_sound",
	"Qt::Key_Dead_Semivoiced_Sound",
	"GDK_KEY_dead_belowdot",
	"Qt::Key_Dead_Belowdot",
	"GDK_KEY_dead_hook",
	"Qt::Key_Dead_Hook",
	"GDK_KEY_dead_horn",
	"Qt::Key_Dead_Horn",
	"GDK_KEY_dead_stroke",
	"GDK_KEY_dead_abovecomma",
	"GDK_KEY_dead_psili",
	"GDK_KEY_dead_abovereversedcomma",
	"GDK_KEY_dead_dasia",
	"GDK_KEY_dead_doublegrave",
	"GDK_KEY_dead_belowring",
	"GDK_KEY_dead_belowmacron",
	"GDK_KEY_dead_belowcircumflex",
	"GDK_KEY_dead_belowtilde",
	"GDK_KEY_dead_belowbreve",
	"GDK_KEY_dead_belowdiaeresis",
	"GDK_KEY_dead_invertedbreve",
	"GDK_KEY_dead_belowcomma",
	"GDK_KEY_dead_currency",
	"GDK_KEY_dead_a",
	"GDK_KEY_dead_A",
	"GDK_KEY_dead_e",
	"GDK_KEY_dead_E",
	"GDK_KEY_dead_i",
	"GDK_KEY_dead_I",
	"GDK_KEY_dead_o",
	"GDK_KEY_dead_O",
	"GDK_KEY_dead_u",
	"GDK_KEY_dead_U",
	"GDK_KEY_dead_small_schwa",
	"GDK_KEY_dead_capital_schwa",
	"GDK_KEY_dead_greek",*/
	"F1",
	"F2",
	"F3",
	"F4",
	"F5",
	"F6",
	"F7",
	"F8",
	"F9",
	"F10",
	"F11",
	"F12",
	"F13",
	"F14",
	"F15",
	"F16",
	"F17",
	"F18",
	"F19",
	"F20",
	"Soft1",
	"Soft2",
	"Soft3",
	"Soft4",
	"AppSwitch",
	"Call",
	"Camera",
	"CameraFocus",
	"EndCall",
	"GoBack",
	"GoHome",
	"HeadsetHook",
	"LastNumberRedial",
	"Notification",
	"MannerMode",
	"VoiceDial",
	"ChannelDown",
	"ChannelUp",
	"MediaFastForward",
	"MediaPause",
	"MediaPlay",
	"MediaPlayPause",
	"MediaRecord",
	"MediaRewind",
	"MediaStop",
	"MediaTrackNext",
	"MediaTrackPrevious",
	"AudioBalanceLeft",
	"AudioBalanceRight",
	"AudioBassDown",
	"AudioBassBoostDown",
	"AudioBassBoostToggle",
	"AudioBassBoostUp",
	"AudioBassUp",
	"AudioFaderFront",
	"AudioFaderRear",
	"AudioSurroundModeNext",
	"AudioTrebleDown",
	"AudioTrebleUp",
	"AudioVolumeDown",
	"AudioVolumeMute",
	"AudioVolumeUp",
	"MicrophoneToggle",
	"MicrophoneVolumeDown",
	"MicrophoneVolumeMute",
	"MicrophoneVolumeUp",
	"TV",
	"TV3DMode",
	"TVAntennaCable",
	"TVAudioDescription",
	"TVAudioDescriptionMixDown",
	"TVAudioDescriptionMixUp",
	"TVContentsMenu",
	"TVDataService",
	"TVInput",
	"TVInputComponent1",
	"TVInputComponent2",
	"TVInputComposite1",
	"TVInputComposite2",
	"TVInputHDMI1",
	"TVInputHDMI2",
	"TVInputHDMI3",
	"TVInputHDMI4",
	"TVInputVGA1",
	"TVMediaContext",
	"TVNetwork",
	"TVNumberEntry",
	"TVPower",
	"TVRadioService",
	"TVSatellite",
	"TVSatelliteBS",
	"TVSatelliteCS",
	"TVSatelliteToggle",
	"TVTerrestrialAnalog",
	"TVTerrestrialDigital",
	"TVTimer",
	"AVRInput",
	"AVRPower",
	"ColorF0Red",
	"ColorF1Green",
	"ColorF2Yellow",
	"ColorF3Blue",
	"ColorF4Grey",
	"ColorF5Brown",
	"ClosedCaptionToggle",
	"Dimmer",
	"DisplaySwap",
	"DVR",
	"Exit",
	"FavoriteClear0",
	"FavoriteClear1",
	"FavoriteClear2",
	"FavoriteClear3",
	"FavoriteRecall0",
	"FavoriteRecall1",
	"FavoriteRecall2",
	"FavoriteRecall3",
	"FavoriteStore0",
	"FavoriteStore1",
	"FavoriteStore2",
	"FavoriteStore3",
	"Guide",
	"GuideNextDay",
	"GuidePreviousDay",
	"Info",
	"InstantReplay",
	"Link",
	"ListProgram",
	"LiveContent",
	"Lock",
	"MediaApps",
	"MediaAudioTrack",
	"MediaLast",
	"MediaSkipBackward",
	"MediaSkipForward",
	"MediaStepBackward",
	"MediaStepForward",
	"MediaTopMenu",
	"NavigateIn",
	"NavigateNext",
	"NavigateOut",
	"NavigatePrevious",
	"NextFavoriteChannel",
	"NextUserProfile",
	"OnDemand",
	"Pairing",
	"PinPDown",
	"PinPMove",
	"PinPToggle",
	"PinPUp",
	"PlaySpeedDown",
	"PlaySpeedReset",
	"PlaySpeedUp",
	"RandomToggle",
	"RcLowBattery",
	"RecordSpeedNext",
	"RfBypass",
	"ScanChannelsToggle",
	"ScreenModeNext",
	"Settings",
	"SplitScreenToggle",
	"STBInput",
	"STBPower",
	"Subtitle",
	"Teletext",
	"VideoModeNext",
	"Wink",
	"ZoomToggle",
	"SpeechCorrectionList",
	"SpeechInputToggle",
	"Close",
	"New",
	"Open",
	"Print",
	"Save",
	"SpellCheck",
	"MailForward",
	"MailReply",
	"MailSend",
	"LaunchCalculator",
	"LaunchCalendar",
	"LaunchContacts",
	"LaunchMail",
	"LaunchMediaPlayer",
	"LaunchMusicPlayer",
	"LaunchMyComputer",
	"LaunchPhone",
	"LaunchScreenSaver",
	"LaunchSpreadsheet",
	"LaunchWebBrowser",
	"LaunchWebCam",
	"LaunchWordProcessor",
	"LaunchApplication1",
	"LaunchApplication2",
	"LaunchApplication3",
	"LaunchApplication4",
	"LaunchApplication5",
	"LaunchApplication6",
	"LaunchApplication7",
	"LaunchApplication8",
	"LaunchApplication9",
	"LaunchApplication10",
	"LaunchApplication11",
	"LaunchApplication12",
	"LaunchApplication13",
	"LaunchApplication14",
	"LaunchApplication15",
	"LaunchApplication16",
	"BrowserBack",
	"BrowserFavorites",
	"BrowserForward",
	"BrowserHome",
	"BrowserRefresh",
	"BrowserSearch",
	"BrowserStop",
	"Decimal",
	"Key11",
	"Key12",
	"Multiply",
	"Add",
	"Clear",
	"Divide",
	"Subtract",
	"Separator",
];